import { type JSX, type ReactNode } from 'react';
import { cx } from '@linaria/core';
import { Dialog as BaseDialog, DialogBackdrop, type DialogStateReturn, useDialogState } from 'reakit';

import { defaultBackdropStyles, defaultDialogStyles } from './style';

export function Dialog({
  backdropClass,
  children,
  context,
}: {
  backdropClass?: string;
  children: ReactNode;
  context?: DialogStateReturn;
}): JSX.Element {
  const newDialogContext = useDialogState({ animated: true });
  const dialogContext = typeof context !== 'undefined' ? context : newDialogContext;

  return (
    <DialogBackdrop
      {...dialogContext}
      className={backdropClass ? cx(backdropClass, defaultBackdropStyles) : cx(defaultBackdropStyles)}
    >
      <BaseDialog {...dialogContext} aria-label="dialog" className={defaultDialogStyles} tabIndex={0}>
        {children}
      </BaseDialog>
    </DialogBackdrop>
  );
}
